import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, Inject, Injectable, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class ModalService {
  private modalClosedSource = new Subject<void>();

  modalClosed$ = this.modalClosedSource.asObservable();

  closeModal(): void {
    this.modalClosedSource.next();
  }
}

@Component({
  selector: 'app-contact-modal',
  templateUrl: './contact-modal.component.html',
  styleUrls: ['./contact-modal.component.scss']
})

export class ContactModalComponent implements OnInit {

  modalTitle: string;
  modalMessage: any;
  editAddressForm!: FormGroup;
  deleteAddressForm!: FormGroup;
  addAddressForm!: FormGroup;  
  editPhoneForm!: FormGroup;
  deletePhoneForm!: FormGroup;
  addPhoneForm!: FormGroup;  
  addURLForm!: FormGroup;
  editURLForm!: FormGroup;  
  deleteURLForm!: FormGroup;
  addTypeForm!: FormGroup;
  deleteTypeForm!: FormGroup;
  addEmailForm!: FormGroup;
  editEmailForm!: FormGroup;  
  deleteEmailForm!: FormGroup;
  addNoteForm!: FormGroup;
  editNoteForm!: FormGroup;  
  deleteNoteForm!: FormGroup; 
  addNotificationForm!: FormGroup;
  editNotificationForm!: FormGroup;  
  deleteNotificationForm!: FormGroup;   
  editServiceForm!: FormGroup;
  deleteServiceForm!: FormGroup;
  addServiceForm!: FormGroup;    
  editDefaultServiceForm!: FormGroup;
  deleteDefaultServiceForm!: FormGroup;
  addDefaultServiceForm!: FormGroup;  
  uploadDocumentForm!: FormGroup;  


  spinner: boolean = false

  // define arrays of different types for selection dropdown
  typeListContact: string[] = [];

  typeList: string[] = [
    "Main Office",
    "Branch Office",
    "Plant",
    "Warehouse",
    "Home",
    "Store",
    "Mailing",
    "Accounting",
    "Terminal",
    "Job Site",
    "Remittance Address",
    "Physical Address",
  ];

  typeListPhone: string[] = [
    "Work",
    "Home",
    "Mobile",
    "Main",
    "Fax",
    "Pager",
    "Voicemail",
    "Text",
    "Toll Free",
    "Office",
    "After Hours",
    "Other",
  ];

  objListStates: any[] = [
    { "AL": "Alabama" },
    { "AK": "Alaska" },
    { "AZ": "Arizona" },
    { "AR": "Arkansas" },
    { "CA": "California" },
    { "CO": "Colorado" },
    { "CT": "Connecticut" },
    { "DE": "Delaware" },
    { "DC": "District Of Columbia" },
    { "FL": "Florida" },
    { "GA": "Georgia" },
    { "HI": "Hawaii" },
    { "ID": "Idaho" },
    { "IL": "Illinois" },
    { "IN": "Indiana" },
    { "IA": "Iowa" },
    { "KS": "Kansas" },
    { "KY": "Kentucky" },
    { "LA": "Louisiana" },
    { "ME": "Maine" },
    { "MD": "Maryland" },
    { "MA": "Massachusetts" },
    { "MI": "Michigan" },
    { "MN": "Minnesota" },
    { "MS": "Mississippi" },
    { "MO": "Missouri" },
    { "MT": "Montana" },
    { "NE": "Nebraska" },
    { "NV": "Nevada" },
    { "NH": "New Hampshire" },
    { "NJ": "New Jersey" },
    { "NM": "New Mexico" },
    { "NY": "New York" },
    { "NC": "North Carolina" },
    { "ND": "North Dakota" },
    { "OH": "Ohio" },
    { "OK": "Oklahoma" },
    { "OR": "Oregon" },
    { "PA": "Pennsylvania" },
    { "RI": "Rhode Island" },
    { "SC": "South Carolina" },
    { "SD": "South Dakota" },
    { "TN": "Tennessee" },
    { "TX": "Texas" },
    { "UT": "Utah" },
    { "VT": "Vermont" },
    { "VA": "Virginia" },
    { "WA": "Washington" },
    { "WV": "West Virginia" },
    { "WI": "Wisconsin" },
    { "WY": "Wyoming" },
    { "PR": "Puerto Rico" },
    { "VI": "Virgin Islands" }
  ]

  typeListCountry: string[] = [
    "Canada",
    "United States"
  ]

  typeListProvince: string[] = [
    "Alberta",
    "British Columbia",
    "Manitoba",
    "New Brunswick",
    "Newfoundland and Labrador",
    "Nova Scotia",
    "Northwest Territories",
    "Nunavut",
    "Ontario",
    "Prince Edward Island",
    "Quebec",
    "Saskatchewan",
    "Yukon"
  ]

  typeListStates: string[] = [
    "Alabama",
    "Alaska",
    "Arizona",
    "Arkansas",
    "California",
    "Colorado",
    "Connecticut",
    "Delaware",
    "District Of Columbia",
    "Florida",
    "Georgia",
    "Hawaii",
    "Idaho",
    "Illinois",
    "Indiana",
    "Iowa",
    "Kansas",
    "Kentucky",
    "Louisiana",
    "Maine",
    "Maryland",
    "Massachusetts",
    "Michigan",
    "Minnesota",
    "Mississippi",
    "Missouri",
    "Montana",
    "Nebraska",
    "Nevada",
    "New Hampshire",
    "New Jersey",
    "New Mexico",
    "New York",
    "North Carolina",
    "North Dakota",
    "Ohio",
    "Oklahoma",
    "Oregon",
    "Pennsylvania",
    "Rhode Island",
    "South Carolina",
    "South Dakota",
    "Tennessee",
    "Texas",
    "Utah",
    "Vermont",
    "Virginia",
    "Washington",
    "West Virginia",
    "Wisconsin",
    "Wyoming"
  ]

  contactTypeList: string[] = [
     "Default",
      "Manufacturer",
      "Service Provider",
      "Contractor",
      "Shipper",
      "Receiver Consignee",
      "Carrier",
      "Payment Processor",
      "Vendor",
      "Reseller",
      "Distributor",
      "Agent",
      "Friend",
      "Family",
      "volunteer",
      "Company Division",
      "Driver",
      "APP Client",
      "Logistics Broker",
      "Customs Broker",
      "Customer Bill To",
      "Insurance Agent",
      "Prospects",
      "Hot Prospects",
      "Representatives",
      "Business Reference",
      "Warehouse Terminal"
  ];

  typeListService: string[] = [
    "Accessorial Service",
    "Service Program",
    "Surcharge Service",
    "Tradeshow Service",
    "Trailer Build Service",
    "Suncor Service",
    "Customs Service",
    "Delivery Service",
    "Pickup Service",
  ]

  typeListServiceType: string[] = [
    "Delivery After Hours",
    "Delivery Appointment",
    "Delivery Detention",
    "Delivery Rate",
    "Delivery Extra",
    "Delivery Inside",
    "Re-Delivery",
    "Delivery Residential",
    "Delivery Tailgate",
    "Delivery Weekend",
    "Delivery Notification",
    "Delivery Straight Truck",
    "Delivery Time Specific",
    "Delivery Date Time Specific",
    "Split Delivery",
    "Delivery Downtown",
    "Delivery Highcost Area",
    "Delivery Limited Access",
    "Delivery Attempted",
    "Delivery Advance Hours",
    "Delivery Certified",
    "Delivery Back Door",
  ]

  documentType: string[] = [
    "Insurance Document",
    "License",
    "Letter Head",
    "Corporate Registry",
    "Assignment Letter",
    "Reference Letter",
    "Other Document"
  ];

  suggestions: string[] = [];
  selectedValue: string = '';
  
  constructor(
    public dialogRef: MatDialogRef<ContactModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private http: HttpClient,
    private toastr: ToastrService,
    private modalService: ModalService,
    private formBuilder: FormBuilder
  ) {
    this.modalTitle = data.data.modalTitle;
    this.modalMessage = data.data.modalMessage;

    console.log('Modal Message:', this.modalMessage);

    this.deleteAddressForm = this.fb.group({
      contact_address_uuid: this.modalMessage.contact_address_uuid,      
      address_street: this.modalMessage.address_street
    });

    this.addAddressForm = this.fb.group({
        contact_uuid: this.modalMessage.contact_uuid,
        address_type: '',
        address_street: '',
        address_extended: '',
        address_community: '',
        address_locality: '',
        address_region: '',
        address_postal_code: '',
        address_country: '',
        address_description: ''      
    });    

    this.editAddressForm = this.fb.group({
      contact_uuid: this.modalMessage.contact_uuid,
      contact_address_uuid: this.modalMessage.contact_address_uuid,
      address_type: this.modalMessage.address_type,
      address_street: this.modalMessage.address_street,
      address_extended: this.modalMessage.address_extended,
      address_community: this.modalMessage.address_community,
      address_locality: this.modalMessage.address_locality,
      address_region: this.modalMessage.address_region,
      address_postal_code: this.modalMessage.address_postal_code,
      address_country: this.modalMessage.address_country,
      address_description: this.modalMessage.address_description
    });    

    this.editPhoneForm = this.fb.group({
      contact_uuid: this.modalMessage.contact_uuid,
      contact_phone_uuid: this.modalMessage.contact_phone_uuid,
      phone_type: this.modalMessage.phone_type,
      phone_number: this.modalMessage.phone_number,
      phone_extension: this.modalMessage.phone_extension,
      phone_description: this.modalMessage.phone_description,
      contact_name: this.modalMessage.contact_name,
      contact_name_given: this.modalMessage.contact_name_given,
      contact_name_family: this.modalMessage.contact_name_family,
      contact_email: this.modalMessage.contact_email
    });    

    this.addPhoneForm = this.fb.group({
        contact_uuid: this.modalMessage.contact_uuid,
        phone_type: '',
        phone_number: '',
        phone_extension: '',
        phone_description: '',
        contact_name: '',
        contact_name_given: '',
        contact_name_family: '',
        contact_email: ''
    });  

    this.deletePhoneForm = this.fb.group({
      contact_phone_uuid: this.modalMessage.contact_phone_uuid,      
      phone_number: this.modalMessage.phone_number
    });


    this.addTypeForm = this.fb.group({
        contact_uuid: this.modalMessage.contact_uuid,
        contact_type: '',
        contact_type_no: 0,
    });  

    this.deleteTypeForm = this.fb.group({
      contact_type_uuid: this.modalMessage.contact_type_uuid,      
      contact_type: this.modalMessage.contact_type
    });

    this.editURLForm = this.fb.group({
      contact_uuid: this.modalMessage.contact_uuid,    
      contact_url_uuid: this.modalMessage.contact_url_uuid,        
      url_type: this.modalMessage.url_type,
      url_label: this.modalMessage.url_label,
      url_primary: this.modalMessage.url_primary,
      url_address: this.modalMessage.url_address,
      url_description: this.modalMessage.url_description
    });

    this.addURLForm = this.fb.group({
      contact_uuid: this.modalMessage.contact_uuid,    
      url_type: '',
      url_label: '',
      url_primary: 1,
      url_address: '',
      url_description: ''
    });

    this.deleteURLForm = this.fb.group({
      contact_url_uuid: this.modalMessage.contact_url_uuid,      
      url_address: this.modalMessage.url_address
    });

    this.editEmailForm = this.fb.group({
      contact_uuid: this.modalMessage.contact_uuid,    
      contact_email_uuid: this.modalMessage.contact_email_uuid,        
      email_label: this.modalMessage.email_label,
      email_address: this.modalMessage.email_address,
      email_description: this.modalMessage.email_description
    });

    this.addEmailForm = this.fb.group({
      contact_uuid: this.modalMessage.contact_uuid,    
      email_label: '',
      email_address: '',
      email_description: ''
    });

    this.deleteEmailForm = this.fb.group({
      contact_email_uuid: this.modalMessage.contact_email_uuid,      
      email_address: this.modalMessage.email_address
    });

    this.editNoteForm = this.fb.group({
      contact_uuid: this.modalMessage.contact_uuid,    
      contact_note_uuid: this.modalMessage.contact_note_uuid,        
      contact_note: this.modalMessage.contact_note,
    });

    this.addNoteForm = this.fb.group({
      contact_uuid: this.modalMessage.contact_uuid,    
      contact_note: '',
    });

    this.deleteNoteForm = this.fb.group({
      contact_note_uuid: this.modalMessage.contact_note_uuid,      
      contact_note: this.modalMessage.contact_note
    });

    this.editNotificationForm = this.fb.group({
      contact_uuid: this.modalMessage.contact_uuid,    
      contact_profile_default_notification_uuid: this.modalMessage.contact_profile_default_notification_uuid,        
      name: this.modalMessage.name,
      at_pick_up: this.modalMessage.at_pick_up,
      at_delivery: this.modalMessage.at_delivery,
      delayed_pick_up: this.modalMessage.delayed_pick_up,
      delayed_delivery: this.modalMessage.delayed_delivery,
      assessorials_incurred: this.modalMessage.assessorials_incurred,
      phone_notification: this.modalMessage.phone_notification,
      sms_notification: this.modalMessage.sms_notification,
      email_notification: this.modalMessage.email_notification,
      appointment_pickup: this.modalMessage.appointment_pickup,
      appointment_delivery: this.modalMessage.appointment_delivery,
    });

    this.addNotificationForm = this.fb.group({
      contact_uuid: this.modalMessage.contact_uuid,    
      name: '',
      at_pick_up: false,
      at_delivery: false,
      delayed_pick_up: false,
      delayed_delivery: false,
      assessorials_incurred: false,
      phone_notification: false,
      sms_notification: false,
      email_notification: false,
      appointment_pickup: false,
      appointment_delivery: false,

    });

    if (this.modalMessage.contactTypeList)
    {
      // Create the tyle list of contacts
      let count:number = 0;

      for (const contact of this.modalMessage.contactTypeList)
      {
          const contact_name =  contact['contact_name'];
          this.typeListContact.push(contact_name);
      }
    }

    this.deleteNotificationForm = this.fb.group({
      contact_profile_default_notification_uuid: this.modalMessage.contact_profile_default_notification_uuid,      
      name: this.modalMessage.name
    });

    this.deleteServiceForm = this.fb.group({
      carrier_service_rate_uuid: this.modalMessage.carrier_service_rate_uuid,      
      carrier_service: this.modalMessage.carrier_service,
      carrier_service_type: this.modalMessage.carrier_service_type
    });

    this.deleteDefaultServiceForm = this.fb.group({
      contact_profile_default_service_uuid: this.modalMessage.contact_profile_default_service_uuid,      
      service: this.modalMessage.service,
      service_type: this.modalMessage.service_type
    });

    this.editServiceForm = this.fb.group({
      carrier_service_rate_uuid: this.modalMessage.carrier_service_rate_uuid,      
      carrier_service: this.modalMessage.carrier_service,
      carrier_service_type: this.modalMessage.carrier_service_type,
      service_option: this.modalMessage.service_option,
      currency_type: this.modalMessage.currency_type,
      flat_rate: this.modalMessage.flat_rate,
      service_taxed: this.modalMessage.service_taxed,
      service_tax_multiplier: this.modalMessage.service_tax_multiplier,
      service_tax_cost: this.modalMessage.service_tax_cost,
      service_note: this.modalMessage.service_note,      
    });

    this.editDefaultServiceForm = this.fb.group({
      contact_profile_default_service_uuid: this.modalMessage.contact_profile_default_service_uuid,      
      service: this.modalMessage.service,
      service_type: this.modalMessage.service_type
    });

    this.addServiceForm = this.fb.group({
        contact_uuid: this.modalMessage.contact_uuid,
        carrier_service: '',
        carrier_service_type: '',
        service_option: '',
        currency_type: '',
        flat_rate: 0,
        service_tax_multiplier: 0,
        service_tax_cost: '',
        service_note: '',
    });  

    this.addDefaultServiceForm = this.fb.group({
        contact_uuid: this.modalMessage.contact_uuid,
        service: '',
        service_type: '',
    });      

    this.uploadDocumentForm = this.fb.group({
        document_type: '',
        file_description: ''
    });        
  }

  getValueContacts() {
    return Object.values(this.typeListContact);
  }
  ngOnInit(): void {

  }

  deleteAddress() {
    const delete_address_url = `/api/contacts/contact_details.php?contact_address_uuid=${this.modalMessage.contact_address_uuid}`;

    return this.http.delete<any>(delete_address_url)
      .subscribe(response => {
          this.closeModal();
          this.toastr.success('You deleted the Address successfully.', "SUCCESS", {
                positionClass : "toast-center-center",
            });    
      })
  }

  editAddress() {
    const addressObj = this.editAddressForm.value;

    var postData = {
      ['addresses']: [addressObj],
    }
    const add_address_url = `/api/contacts/contact_details.php?uuid=${this.modalMessage.contact_uuid}`;

    this.spinner = true;

    return this.http.put<any>(add_address_url, postData)
      .subscribe(response => {
          this.toastr.success('You edited the Address successfully.', "SUCCESS", {
                positionClass : "toast-center-center",
            });    
          this.spinner = false;          
          this.closeModal();
      })
  }

  addAddress() {
    const addressObj = this.addAddressForm.value;

    var postData = {
      ['addresses']: [addressObj],
    }
    const add_address_url = `/api/contacts/contact_details.php?uuid=${this.modalMessage.contact_uuid}`;
    this.spinner = true;

    return this.http.put<any>(add_address_url, postData)
      .subscribe(response => {
          this.closeModal();
          this.spinner = false;                 
          this.toastr.success('You added the Address successfully.', "SUCCESS", {
                positionClass : "toast-center-center",
            });   
      })
  }

  editPhone() {
    const phoneObj = this.editPhoneForm.value;

    var postData = {
      ['sub_contacts']: [phoneObj],
    }
    const edit_phone_url = `/api/contacts/contact_details.php?uuid=${this.modalMessage.contact_uuid}`;

    return this.http.put<any>(edit_phone_url, postData)
      .subscribe(response => {
          this.closeModal();
          this.toastr.success('You edited the Sub Contact successfully.', "SUCCESS", {
                positionClass : "toast-center-center",
            });           
      })
  }

  addPhone() {
    const phoneObj = this.addPhoneForm.value;

    var postData = {
      ['sub_contacts']: [phoneObj],
    }
    const add_phone_url = `/api/contacts/contact_details.php?uuid=${this.modalMessage.contact_uuid}`;

    return this.http.put<any>(add_phone_url, postData)
      .subscribe(response => {
          this.closeModal();
          this.toastr.success('You added the Sub Contact successfully.', "SUCCESS", {
                positionClass : "toast-center-center",
            });    
      })
  }

  
  deletePhone() {
    const delete_phone_url = `/api/contacts/contact_details.php?contact_phone_uuid=${this.modalMessage.contact_phone_uuid}`;

    return this.http.delete<any>(delete_phone_url)
      .subscribe(response => {
          this.closeModal();
          this.toastr.success('You deleted the Sub Contact successfully.', "SUCCESS", {
                positionClass : "toast-center-center",
            });    
      })
  }

  addURL() {
    const urlObj = this.addURLForm.value;

    var postData = {
      ['urls']: [urlObj],
    }
    const add_contact_url = `/api/contacts/contact_details.php?uuid=${this.modalMessage.contact_uuid}`;

    return this.http.put<any>(add_contact_url, postData)
      .subscribe(response => {
          this.closeModal();
          this.toastr.success('You added the Contact URL successfully.', "SUCCESS", {
                positionClass : "toast-center-center",
            });    
      })
  }

  editURL() {
    const urlObj = this.editURLForm.value;

    var postData = {
      ['urls']: [urlObj],
    }
    const edit_contact_url = `/api/contacts/contact_details.php?uuid=${this.modalMessage.contact_uuid}`;

    return this.http.put<any>(edit_contact_url, postData)
      .subscribe(response => {
          this.closeModal();
          this.toastr.success('You edited the Contact URL successfully.', "SUCCESS", {
                positionClass : "toast-center-center",
            });    
      })
  }

  deleteURL() {
    const delete_url_url = `/api/contacts/contact_details.php?contact_type_uuid=${this.modalMessage.contact_type_uuid}`;

    return this.http.delete<any>(delete_url_url)
      .subscribe(response => {
          this.closeModal();
          this.toastr.success('You deleted the URL successfully.', "SUCCESS", {
                positionClass : "toast-center-center",
            });    
      })
  }

  addType() {
    const typeObj = this.addTypeForm.value;

    var postData = {
      ['types']: [typeObj],
    }
    const add_contact_url = `/api/contacts/contact_details.php?uuid=${this.modalMessage.contact_uuid}`;

    return this.http.put<any>(add_contact_url, postData)
      .subscribe(response => {
          this.closeModal();
          this.toastr.success('You added the Contact Type successfully.', "SUCCESS", {
                positionClass : "toast-center-center",
            });    
      })
  }

  deleteType() {
    const typeObj = this.deleteTypeForm.value;

    const delete_service_url = `/api/contacts/contact_details.php?contact_type_uuid=${this.modalMessage.contact_type_uuid}`;

    return this.http.delete<any>(delete_service_url)
      .subscribe(response => {
          this.closeModal();
          this.toastr.success('You deleted the Carrier Service successfully.', "SUCCESS", {
                positionClass : "toast-center-center",
            });    
      })
  }

  addEmail() {
    const emailObj = this.addEmailForm.value;

    var postData = {
      ['emails']: [emailObj],
    }
    const add_contact_email_url = `/api/contacts/contact_details.php?uuid=${this.modalMessage.contact_uuid}`;

    return this.http.put<any>(add_contact_email_url, postData)
      .subscribe(response => {
          this.closeModal();
          this.toastr.success('You added the Contact Email successfully.', "SUCCESS", {
                positionClass : "toast-center-center",
            });    
      })
  }

  editEmail() {
    const emailObj = this.editEmailForm.value;

    var postData = {
      ['emails']: [emailObj],
    }
    const edit_email_url = `/api/contacts/contact_details.php?uuid=${this.modalMessage.contact_uuid}`;

    return this.http.put<any>(edit_email_url, postData)
      .subscribe(response => {
          this.closeModal();
          this.toastr.success('You edited the Contact Email successfully.', "SUCCESS", {
                positionClass : "toast-center-center",
            });    
      })
  }

  deleteEmail() {
    const delete_email_url = `/api/contacts/contact_details.php?contact_email_uuid=${this.modalMessage.contact_email_uuid}`;

    return this.http.delete<any>(delete_email_url)
      .subscribe(response => {
          this.closeModal();
          this.toastr.success('You deleted the Email successfully.', "SUCCESS", {
                positionClass : "toast-center-center",
            });    
      })
  }

  addNote() {
    const noteObj = this.addNoteForm.value;

    var postData = {
      ['notes']: [noteObj],
    }
    const add_note_url = `/api/contacts/contact_details.php?uuid=${this.modalMessage.contact_uuid}`;

    return this.http.put<any>(add_note_url, postData)
      .subscribe(response => {
          this.closeModal();
          this.toastr.success('You added the Contact Note successfully.', "SUCCESS", {
                positionClass : "toast-center-center",
            });    
      })
  }

  editNote() {
    const noteObj = this.editNoteForm.value;

    var postData = {
      ['notes']: [noteObj],
    }
    const edit_note_url = `/api/contacts/contact_details.php?uuid=${this.modalMessage.contact_uuid}`;

    return this.http.put<any>(edit_note_url, postData)
      .subscribe(response => {
          this.closeModal();
          this.toastr.success('You edited the Contact Note successfully.', "SUCCESS", {
                positionClass : "toast-center-center",
            });    
      })
  }

  deleteNote() {
    const delete_note_url = `/api/contacts/contact_details.php?contact_note_uuid=${this.modalMessage.contact_note_uuid}`;

    return this.http.delete<any>(delete_note_url)
      .subscribe(response => {
          this.closeModal();
          this.toastr.success('You deleted the Note successfully.', "SUCCESS", {
                positionClass : "toast-center-center",
            });    
      })
  }

  addNotification() {
    const notificationObj = this.addNotificationForm.value;
    notificationObj.at_pick_up = notificationObj.at_pick_up ? 't' : 'f';
    notificationObj.delayed_pick_up = notificationObj.delayed_pick_up ? 't' : 'f';
    notificationObj.at_delivery = notificationObj.at_delivery ? 't' : 'f';
    notificationObj.delayed_delivery = notificationObj.delayed_delivery ? 't' : 'f';
    notificationObj.assessorials_incurred = notificationObj.assessorials_incurred ? 't' : 'f';
    notificationObj.phone_notification = notificationObj.phone_notification ? 't' : 'f';
    notificationObj.sms_notification = notificationObj.sms_notification ? 't' : 'f';
    notificationObj.email_notification = notificationObj.email_notification ? 't' : 'f';
    notificationObj.appointment_pickup = notificationObj.appointment_pickup ? 't' : 'f';
    notificationObj.appointment_delivery = notificationObj.appointment_delivery ? 't' : 'f';

    for (const contact of this.modalMessage.contactTypeList)
    {
        if (contact['contact_name'] == notificationObj['name'])
        {
          notificationObj['contact_phone_uuid'] = contact['contact_phone_uuid'];
          notificationObj['email']              = contact['contact_email'];
          notificationObj['phone_number']       = contact['phone_number'];
          notificationObj['phone_number']       = contact['phone_number'];
        }
    }
    var postData = {
      ['profile_default_notifications']: [notificationObj],
    }

    const add_notification_url = `/api/contacts/contact_details.php?uuid=${this.modalMessage.contact_uuid}`;
    
    return this.http.put<any>(add_notification_url, postData)
      .subscribe(response => {
          this.closeModal();
          this.toastr.success('You added the Contact Notication successfully.', "SUCCESS", {
                positionClass : "toast-center-center",
            });    
      })
  }

  editNotification() {
    const notificationObj = this.editNotificationForm.value;
    notificationObj.at_pick_up = notificationObj.at_pick_up ? 't' : 'f';
    notificationObj.delayed_pick_up = notificationObj.delayed_pick_up ? 't' : 'f';
    notificationObj.at_delivery = notificationObj.at_delivery ? 't' : 'f';
    notificationObj.delayed_delivery = notificationObj.delayed_delivery ? 't' : 'f';
    notificationObj.assessorials_incurred = notificationObj.assessorials_incurred ? 't' : 'f';
    notificationObj.phone_notification = notificationObj.phone_notification ? 't' : 'f';
    notificationObj.sms_notification = notificationObj.sms_notification ? 't' : 'f';
    notificationObj.email_notification = notificationObj.email_notification ? 't' : 'f';
    notificationObj.appointment_pickup = notificationObj.appointment_pickup ? 't' : 'f';
    notificationObj.appointment_delivery = notificationObj.appointment_delivery ? 't' : 'f';
    for (const contact of this.modalMessage.contactTypeList)
    {
        if (contact['contact_name'] == notificationObj['name'])
        {
          notificationObj['contact_phone_uuid'] = contact['contact_phone_uuid'];
          notificationObj['email']              = contact['contact_email'];
          notificationObj['phone_number']       = contact['phone_number'];
          notificationObj['phone_number']       = contact['phone_number'];
        }
    }

    var postData = {
      ['profile_default_notifications']: [notificationObj],
    }
    const edit_notificatoin_url = `/api/contacts/contact_details.php?uuid=${this.modalMessage.contact_uuid}`;
    return this.http.put<any>(edit_notificatoin_url, postData)
      .subscribe(response => {
          this.closeModal();
          this.toastr.success('You edited the Contact Notication successfully.', "SUCCESS", {
                positionClass : "toast-center-center",
            });    
      })
  }

  deleteNotification() {
    const delete_notification_url = `/api/contacts/contact_details.php?contact_profile_default_notification_uuid=${this.modalMessage.contact_profile_default_notification_uuid}`;
    console.log('Delete Notification Url:', delete_notification_url);

    return this.http.delete<any>(delete_notification_url)
      .subscribe(response => {
          console.log('Delete Notification Response:', response);
          this.closeModal();
          this.toastr.success('You deleted the Notication successfully.', "SUCCESS", {
                positionClass : "toast-center-center",
            });    
      })
  }

  deleteService() {
    const delete_service_url = `/api/contacts/contact_details.php?contact_profile_default_service_uuid=${this.modalMessage.contact_profile_default_service_uuid}`;

    return this.http.delete<any>(delete_service_url)
      .subscribe(response => {
          this.closeModal();
          this.toastr.success('You deleted the default service successfully.', "SUCCESS", {
                positionClass : "toast-center-center",
            });    
      })
  }

  editService() {
    const serviceObj = this.editServiceForm.value;

    var postData = {
      ['profile_default_services']: [serviceObj],
    }
    const edit_service_url = `/api/contacts/contact_details.php?uuid=${this.modalMessage.contact_uuid}`;

    return this.http.put<any>(edit_service_url, postData)
      .subscribe(response => {

          this.closeModal();
          this.toastr.success('You edited the profile default service successfully.', "SUCCESS", {
                positionClass : "toast-center-center",
            });    
      })
  }
  
  addService() {
    const serviceObj = this.addServiceForm.value;

    var postData = {
      ['profile_default_services']: [serviceObj],
    }
    const add_service_url = `/api/contacts/contact_details.php?uuid=${this.modalMessage.contact_uuid}`;

    return this.http.put<any>(add_service_url, postData)
      .subscribe(response => {
          this.closeModal();
          this.toastr.success('You added the profile Default Service successfully.', "SUCCESS", {
                positionClass : "toast-center-center",
            });    
      })
  }

  deleteDefaultService() {
    const phoneObj = this.deleteTypeForm.value;

    const delete_phone_url = `/api/contacts/contact_details.php?contact_type_uuid=${this.modalMessage.contact_type_uuid}`;

    return this.http.delete<any>(delete_phone_url)
      .subscribe(response => {
          this.closeModal();
          this.toastr.success('You deleted the default Service successfully.', "SUCCESS", {
                positionClass : "toast-center-center",
            });    
      })
  }

  editDefaultService() {
    const edit_address_url = `/api/shipment_lists/shipment_details.php?table=shipment_and_receiving&command=EDIT_SHIPMENT_DETAILS`;
    const addressObj = this.editAddressForm.value;

    var postData = {
      ...addressObj,
      contact_uuid: this.modalMessage.uuid
    }

    return this.http.post<any>(edit_address_url, postData)
      .subscribe(response => {
        console.log('Post Response: ', response);
          this.toastr.success('You edited the default service successfully.', "SUCCESS", {
                positionClass : "toast-center-center",
            }); 
          this.closeModal();
      })
  }
  
  addDefaultService() {
    const add_service_url = `/api/shipment_lists/shipment_details.php?table=shipment_and_receiving&command=EDIT_SHIPMENT_DETAILS`;
    const addressObj = this.addServiceForm.value;

    var postData = {
      ...addressObj,
      contact_uuid: this.modalMessage.uuid
    }

    return this.http.post<any>(add_service_url, postData)
      .subscribe(response => {
        console.log('Post Response: ', response);
          this.toastr.success('You added a Default service successfully.', "SUCCESS", {
                positionClass : "toast-center-center",
            });         
          this.closeModal();
      })
  }

  uploadDocumentType() {
    const uploadDocumentObj = this.uploadDocumentForm.value;
    console.log('Post Data:', uploadDocumentObj);
    this.dialogRef.close(uploadDocumentObj); 
  }

  closeModal() {
    this.dialogRef.close();
  }
  
  getAddressStates(country: string): string[] {
    if (country === 'Canada') {
      return this.typeListProvince;
    } else if (country === 'United States') {
      return this.typeListStates;
    } else {
      return [];
    }
  }

  onCountryChange() {
    const addressFormGroup = this.addAddressForm;
    const countryControl = addressFormGroup?.get('address_country');
    const stateControl = addressFormGroup?.get('address_region');
    const states = this.getAddressStates(countryControl?.value);
    stateControl?.setValue(null);
    stateControl?.setValidators(states.length > 0 ? Validators.required : null);
    stateControl?.updateValueAndValidity();

    const editAddressFormGroup = this.editAddressForm;
    const editCountryControl = editAddressFormGroup?.get('address_country');
    const editStateControl = editAddressFormGroup?.get('address_region');
    const editStates = this.getAddressStates(editCountryControl?.value);
    editStateControl?.setValue(null);
    editStateControl?.setValidators(states.length > 0 ? Validators.required : null);
    editStateControl?.updateValueAndValidity();    
  }

 onTypeChange() {
    const addTypeForm = this.addTypeForm;
    const contact_type_control = addTypeForm?.get('contact_type');
    const contact_type_no_control = addTypeForm?.get('contact_type_no');
    const contact_type = contact_type_control?.value;
    console.log('Contact Type:', contact_type);
    const offset = this.contactTypeList.indexOf(contact_type);
    contact_type_no_control?.setValue(offset);
  }


  getAddressFirstPart(suggestion: string): string {
      const firstPart = suggestion.substring(0, suggestion.indexOf(',')).trim();
      return firstPart;
    }

  onOptionSelected(event: MatAutocompleteSelectedEvent): void {
    // for (const item of this.addresses) {
    // this.addressForm = item;

    this.addAddressForm.get('address_street')?.setValue(this.getAddressFirstPart(event.option.value));
    // this.addressForm.get('address_street')?.setValue(this.getAddressFirstPart(event.option.value));
    this.editAddressForm.get('address_street')?.setValue(this.getAddressFirstPart(event.option.value));

    const suggestion = event.option.value;
    const parts = suggestion.split(',')
    const lastPart = parts[parts.length - 1].trim()
    const middlePart = parts[parts.length - 2].trim();
    const url = "/api/postgrid_api/verify_address.php?name=countryandstate";
    const params = {
      postalOrZip: lastPart,
    }

    this.addAddressForm.get('address_locality')?.setValue(middlePart);
    this.addAddressForm.get('address_postal_code')?.setValue(lastPart);

    this.editAddressForm.get('address_locality')?.setValue(middlePart);
    this.editAddressForm.get('address_postal_code')?.setValue(lastPart);


    this.http.get<any>(url, { params }).subscribe((response) => {
      let province = '';
      if (response.data[0]?.country == 'CA') {
        this.addAddressForm.get('address_country')?.setValue('Canada');
        this.editAddressForm.get('address_country')?.setValue('Canada');
        switch (response.data[0].provinceOrState) {
          case 'AB':
            province = 'Alberta'
            break;

          case 'ON':
            province = "Ontario";
            break;

          case 'BC':
            province = "British Columbia";
            break;

          case 'MB':
            province = "Manitoba";
            break;

          case 'NB':
            province = "New Brunswick";
            break;

          case 'NL':
            province = "Newfoundland and Labrador";
            break;

          case 'NT':
            province = "Northwest Territories";
            break;

          case 'NS':
            province = "Nova Scotia";
            break;

          case 'NU':
            province = "Nunavut";
            break;

          case 'PE':
            province = "Prince Edward Island";
            break;

          case 'QC':
            province = "Quebec";
            break;

          case 'SK':
            province = "Saskatchewan";
            break;

          case 'YT':
            province = "Yukon";
            break;

          default:
            console.log("Province is not valid");
        }
        this.addAddressForm.get('address_region')?.setValue(province);
        this.editAddressForm.get('address_region')?.setValue(province);
      }
      else {
        this.addAddressForm.get('address_country')?.setValue('United States');
        this.editAddressForm.get('address_country')?.setValue('United States');
        let state = '';
        this.objListStates.map(item => {
          if (response.data[0]?.provinceOrState == Object.keys(item)[0]) {
            state = item[Object.keys(item)[0]];
            return item[Object.keys(item)[0]];
          }

        })
        this.addAddressForm.get('address_region')?.setValue(state);
        this.editAddressForm.get('address_region')?.setValue(state);
      }
    })
    // }
  }  
    
}
